import { render, staticRenderFns } from "./Page_Main.vue?vue&type=template&id=94596cce&scoped=true&"
import script from "./Page_Main.vue?vue&type=script&lang=js&"
export * from "./Page_Main.vue?vue&type=script&lang=js&"
import style0 from "./Page_Main.vue?vue&type=style&index=0&id=94596cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94596cce",
  null
  
)

export default component.exports